module.exports = __webpack_public_path__ + "static/media/ic_full_screen_stop.b7e4d1c3.svg";